import ClientsAxios from "../../client-axios";
import { ResponseEntity } from "../../dto/response";
// const { API_SERVER } = ClientsAxios;

const { API_SERVER } = ClientsAxios;

export const StoreUpdateNewApplicationService = async (payload: any, isUpdate: boolean) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post(isUpdate ? 'beneficiaries/update' : 'beneficiaries/create', payload, { headers: { 'Content-Type': 'multipart/form-data' } })
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response ?? {};
        responseEntity.error(response?.StatusCode ?? 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const StoreUpdateNewBeneficiaryApplicationService = async (payload: any, isUpdate: boolean) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post(isUpdate ? 'project/beneficiaries/update' : 'project/beneficiaries/create', payload, { headers: { 'Content-Type': 'multipart/form-data' } })
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response ?? {};
        responseEntity.error(response?.StatusCode ?? 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}
export const FetchApplicationListService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.post('beneficiaries/list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response ?? {};
        responseEntity.error(response?.StatusCode ?? 500, error?.Message, response?.data?.body ?? {})
    }
    return responseEntity
}
export const FetchCategoryDropDownService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.post('beneficiaries/category-dropdown', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response ?? {};
        responseEntity.error(response?.StatusCode ?? 500, error?.Message, response?.data?.body ?? {})
    }
    return responseEntity
}

export const FetchAdharDetailService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.post('beneficiaries/adhar-wise-list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response ?? {};
        responseEntity.error(response?.StatusCode ?? 500, error?.Message, response?.data?.body ?? {})
    }
    return responseEntity
}

export const FetchApplicationDetailService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.post('beneficiaries/details', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response ?? {};
        responseEntity.error(response?.StatusCode ?? 500, error?.Message, response?.data?.body ?? {})
    }
    return responseEntity
}

